import layoutSlice from './layoutSlice';

export const {
  updateListVariant,
  updateShowFilters,
  updateShowChat
} = layoutSlice.actions;
export default layoutSlice.reducer;
